var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoView({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-view 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.6281 9C18.8682 9.06867 22.0223 10.6134 24.4517 13.6248C25.1824 14.5302 25.1811 15.4502 24.4571 16.3529C22.3957 18.9237 19.7502 20.5118 16.4601 20.8824C12.1726 21.3658 8.61984 19.8951 5.77974 16.6676C5.64107 16.5103 5.51573 16.3409 5.39439 16.1703C4.87504 15.4389 4.86304 14.5422 5.39106 13.8202C6.48576 12.3228 7.88448 11.1741 9.52387 10.3194C11.2359 9.42668 13.066 9.00133 15.6281 9ZM14.3801 19.6504C16.4008 19.6504 17.7562 19.3997 19.0502 18.8557C20.8203 18.111 22.303 16.9863 23.469 15.4542C23.7157 15.1302 23.7077 14.8595 23.471 14.5289C23.4317 14.4742 23.393 14.4189 23.3497 14.3669C20.8696 11.4074 17.7122 10.0294 13.8567 10.4027C10.8973 10.6894 8.5085 12.0854 6.63377 14.3762C6.22309 14.8782 6.22242 15.1049 6.6331 15.6049C8.79785 18.2417 11.5873 19.5924 14.3801 19.6504Z",
    fill: "#32976B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.9799 18.3211C13.1445 18.3164 11.6571 16.8143 11.6638 14.9723C11.6704 13.1375 13.1738 11.6535 15.0179 11.6621C16.8426 11.6708 18.326 13.1682 18.3227 14.9989C18.32 16.8363 16.8213 18.3257 14.9799 18.3211ZM16.986 14.9929C16.9873 13.8902 16.1099 13.0069 15.0059 12.9989C13.8945 12.9915 13.0018 13.8782 13.0012 14.9903C13.0005 16.0923 13.8785 16.977 14.9812 16.9843C16.0913 16.9917 16.9846 16.105 16.986 14.9929Z",
    fill: "#32976B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoView);
export default __webpack_public_path__ + "static/media/ico-view.2e491db29575c181e10ecde44db1bf3e.svg";
export { ForwardRef as ReactComponent };